import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';

import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { ImagesFormComponent } from 'src/app/widgets/event-form/images-form/images-form.component';

import { HomepageTemplateComponent } from './templates/homepage/homepage.component';
import { CookiesPolicyTemplateComponent } from './templates/cookies-policy/cookies-policy.component';
import { EventFormComponent } from './templates/event-form/event-form.component';
import { RegisterEventComponent } from './pages/register-event/register-event.component';
import { AppComponent } from './app.component';
import { AncillaryNavComponent } from './widgets/global/ancillary-nav/ancillary-nav.component';
import { HeaderComponent } from './widgets/global/header/header.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { CriteriaComponent } from './pages/criteria/criteria.component';
import { RegisterComponent } from './widgets/homepage/register/register.component';
import { FooterComponent } from './widgets/global/footer/footer.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { WizardComponent } from './widgets/event-form/wizard/wizard.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';

import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from 'src/app/controls/date-picker/moment-date-adapter';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_LOADER_OPTIONS, RecaptchaLoaderOptions } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';

import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OrganiserFormComponent } from './widgets/event-form/organiser-form/organiser-form.component';
import { ChannelsFormComponent } from './widgets/event-form/channels-form/channels-form.component';
import { VenueFormComponent } from './widgets/event-form/venue-form/venue-form.component';
import { DescriptionFormComponent } from './widgets/event-form/description-form/description-form.component';
import { BookingFormComponent } from './widgets/event-form/booking-form/booking-form.component';
import { VideoFormComponent } from './widgets/event-form/video-form/video-form.component';
import { DetailFormComponent } from './widgets/event-form/detail-form/detail-form.component';
import { CriteriaFormComponent } from './widgets/event-form/criteria-form/criteria-form.component';
import { TermsFormComponent } from './widgets/event-form/terms-form/terms-form.component';
import { DatePickerComponent } from './controls/date-picker/date-picker.component';
import { CalendarMonthComponent } from './controls/date-picker/calendar-month/calendar-month.component';
import { PricingFormComponent } from './widgets/event-form/pricing-form/pricing-form.component';


import { environment } from 'src/environments/environment';

// Cookie
// import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { SchemaConverter } from 'src/app/lib/schemaConverter';
import { ContributorService } from './services/contributor.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { MonitoringService } from './services/monitoring.service';
import { CookiesPolicyComponent } from './pages/homepage/cookies-policy/cookies-policy.component';
import { CookiesPolicyContentComponent } from './widgets/homepage/cookies-policy/cookies-policy.component';


// Toastr
import { ToastrModule } from 'ngx-toastr';
import { ReadmeComponent } from 'src/app/widgets/event-form/readme/readme.component';
import { ReviewComponent } from 'src/app/widgets/event-form/review/review.component';
import { DescriptionGuidelinesComponent } from './pages/description-guidelines/description-guidelines.component';
import { ImageGuidelinesComponent } from './pages/image-guidelines/image-guidelines.component';
import { ThankYouComponent } from './pages/thank-you/thank-you.component';
import { FormFooterComponent } from './widgets/global/form-footer/form-footer.component';



@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CommonModule,
    MatMomentDateModule,
    ToastrModule.forRoot(),
    // Standalone components (have their own imports arrays)
    VenueFormComponent,
    ImagesFormComponent,
  ],
  declarations: [
    AppComponent,
    HomepageTemplateComponent,
    HomepageComponent,
    EventFormComponent,
    RegisterEventComponent,
    AncillaryNavComponent,
    HeaderComponent,
    RegisterComponent,
    FooterComponent,
    WizardComponent,
    OrganiserFormComponent,
    TermsConditionsComponent,
    CriteriaComponent,
    ChannelsFormComponent,
    DescriptionFormComponent,
    BookingFormComponent,
    VideoFormComponent,
    DetailFormComponent,
    CriteriaFormComponent,
    TermsFormComponent,
    DatePickerComponent,
    CalendarMonthComponent,
    PricingFormComponent,
    CookiesPolicyComponent,
    CookiesPolicyTemplateComponent,
    CookiesPolicyContentComponent,
    ReadmeComponent,
    ReviewComponent,
    DescriptionGuidelinesComponent,
    ImageGuidelinesComponent,
    ThankYouComponent,
    FormFooterComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_DATE_LOCALE, useValue: 'en-ie' },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.siteKey,
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useValue: {
        onBeforeLoad(url: URL) {
          url.hostname = 'www.recaptcha.net';
          return { url };
        },
      } as RecaptchaLoaderOptions,
    },
    MonitoringService,
    GlobalErrorHandlerService,
    {
      provide: ErrorHandler, useClass: GlobalErrorHandlerService
    },
    ContributorService,
    SchemaConverter
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
